<template>
    <CustomHeader :text="$t('activityName.recharge_gift')" :show-history="true" @openHistoryPopup="openHistoryPopup" />
    <img class="bg-top-img" :src="dataSet.bannerIcon">
    <div class="container">
        <CashbackNotice :content="formattedMessages" />
        <div v-if="dataSet.rechargeBonusStatus == 1" class="immidiateDepositBtn">
            <div class="depositBtn" @click="goToDeposit()"> {{ $t('activity.immediateDeposit') }}</div>
        </div>
        <div>
            <CashBackCard :title="$t('common.bets')" :create-date="dataSet.todayRechargeGiftDetails?.createTime"
                :day="dataSet.todayRechargeGiftDetails?.day"
                :available-value="dataSet.todayRechargeGiftDetails?.availableAmount"
                :showClickButton="dataSet.todayRechargeGiftDetails?.availableAmount > 0"
                :given-value="dataSet.todayRechargeGiftDetails?.givenAmount" @get-claim="getClaim"
                :dayList="dataSet.futureRewards.length <= 0 ? getDefaultRewards(dayCount) : dataSet.futureRewards" />
        </div>

        <CashbackWeekDetails :bet-list="dataSet.weeklyRechargeGiftList" :title="$t('myDataView.totalRecharge')"
            :cashback-total="dataSet.cashbackTotal" type="RECHARGE"
            :istoday-claimed="dataSet.todayRechargeGiftDetails?.availableAmount > 0" />

        <CashbackHistoryPopup ref="histryPopupRef" @getHistoryList="getHistoryList" :list="dataSet.historyList"
            :title="$t('myDataView.totalRecharge')" @updateHistoryList="getNextPageRewardData"
            :showIcon="dataSet.total > dataSet.pageSize * dataSet.pageNum" @resetHistoryData="resetHistoryData" />
    </div>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, defineEmits } from 'vue';
import { getDefaultRewards } from '@/utils/commonFunction';
import { DAY_COUNT, RechargeGiftData } from '@/view/rechargeGift/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import CashbackNotice from '../components/common/cashbackNotice.vue';
import CashBackCard from '../components/common/cashBackCard.vue';
import CashbackWeekDetails from '../components/common/cashbackWeekDetails.vue';
import CashbackHistoryPopup from '../components/common/cashbackHistoryPopup.vue';

const histryPopupRef = ref();

const dayCount = ref(DAY_COUNT)

const props = defineProps<{
    dataSet: RechargeGiftData
}>()

const formattedMessages = computed(() =>
    props.dataSet.activityDescription.map(msg => msg.replace(/\\n/g, '\n'))
);

const emits = defineEmits(['getNextPageRewardData', 'getHistoryList', 'resetHistoryData', 'getClaim','goToDeposit'])

const getNextPageRewardData = () => {
    emits('getNextPageRewardData')
}
const getHistoryList = () => {
    emits('getHistoryList')
}

const resetHistoryData = () => {
    emits('resetHistoryData')
}
const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}
const goToDeposit = () => {
     emits("goToDeposit")
}
const getClaim = () => {
    emits('getClaim')
}

</script>
<style scoped>
.container {
    padding: 0px;
    position: relative;

}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.container>>>.van-tab {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    border-radius: 30px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    padding: 15px;
}

.image-wrapper {
    position: relative;
    display: inline-block;
}

.bottom_text {
    padding: 0px 25px;
    margin-top: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

.bg-top-img {
    width: 100%;
    padding-top: 3rem;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
    padding: 10px;
}
.immidiateDepositBtn{
    display: flex;
    justify-content: center;
    padding: 10px;
}
.depositBtn {
    color: #000;
    background-image: linear-gradient(99deg, #FCD7A1 0%, #D17836 100%);
    border-radius: 10px;
    padding: 10px;
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
}
</style>